import { debounce } from "lodash";

const DEBOUNCE_DELAY = 10;

class MockResizeObserver {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(_cb: any) {}
  observe(_target: Element) {}
  unobserve(_target: Element) {}
  disconnect() {}
}

const OriginalResizeObserver =
  typeof window !== "undefined" && window.ResizeObserver ? window.ResizeObserver : MockResizeObserver;

class SafeResizeObserver extends OriginalResizeObserver {
  private _debouncedCallback: (entries: ResizeObserverEntry[], observer: ResizeObserver) => void;

  constructor(callback: (entries: ResizeObserverEntry[], observer: ResizeObserver) => void) {
    const debouncedCallback = debounce(callback, DEBOUNCE_DELAY);
    super(debouncedCallback);
    this._debouncedCallback = debouncedCallback;
  }

  get debouncedCallback() {
    return this._debouncedCallback;
  }
}

if (typeof window !== "undefined") {
  window.ResizeObserver = SafeResizeObserver;
}

export default SafeResizeObserver;
